import { Icecream, Instagram, LinkedIn, Public } from '@mui/icons-material';
import React from 'react';
import Community from './Community';
import SEO from '../config/SEO';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const About = () => {

      const coreFeatures = [
            {
                  id: '01',
                  title: 'AI Prompt Marketplace',
                  text: 'A focused platform where creators publish, sell, and discover high-quality prompts built for real use cases.',
            },
            {
                  id: '02',
                  title: 'Creator Monetization',
                  text: 'HeyPrompt helps prompt creators turn their skills into digital income through a structured marketplace ecosystem.',
            },
            {
                  id: '03',
                  title: 'Fast Discovery',
                  text: 'Smart browsing, clean categorization, and user-friendly listings make prompt discovery simple and scalable.',
            },
            {
                  id: '04',
                  title: 'Future Ready Vision',
                  text: 'Built for the next generation of AI tools, workflows, and creator-driven digital products.',
            },
      ];

      const stats = [
            { value: '500+', label: 'Prompts Listed' },
            { value: '1K+', label: 'Active Users' },
            { value: '2025', label: 'Founded' },
            { value: '24/7', label: 'Digital Access' },
      ];

      const LinkMedias = [
            {
                  title: 'LinkedIn',
                  url: 'https://www.linkedin.com/in/devsunilsharma/',
                  icon: <LinkedIn />,
            },
            {
                  title: 'Instagram',
                  url: 'https://www.instagram.com/thedc__',
                  icon: <Instagram />,
            },
            {
                  title: 'Snapchat',
                  url: 'https://snapchat.com/t/RzcXS8BN',
                  icon: <Icecream />,
            },
            {
                  title: 'Portfolio Website',
                  url: 'https://buildifytool.cloud/',
                  icon: <Public />,
            },
      ]

      return (

            <>
                  <SEO
                        title="About HeyPrompt | Architecting the AI Creator Economy"
                        description="Discover the vision behind HeyPrompt—a premier marketplace for high-performance AI prompts and the future of generative engineering."
                        keywords="about heyprompt, prompt engineering, sunil sharma ceo, ai marketplace, generative ai vision"
                        canonicalPath="/about"
                  />

                  <main className="about-page">
                        <section className="about-hero">
                              <div className="__container">
                                    <div className="hero-grid">
                                          <div className="hero-left">
                                                <span className="eyebrow">About HeyPrompt</span>
                                                <h1>
                                                      Built for the new era of
                                                      <span> AI creators</span>
                                                </h1>
                                                <p>
                                                      HeyPrompt is a modern AI prompt marketplace designed to help creators,
                                                      builders, and digital entrepreneurs discover, publish, and monetize
                                                      high-value prompts. The goal is simple — make prompt commerce cleaner,
                                                      smarter, and more accessible.
                                                </p>

                                                <div className="hero-actions">
                                                      <a href="/marketplace" className="primary-btn">Explore Marketplace</a>
                                                      <a href="/submit" className="secondary-btn">Submit Prompt</a>
                                                </div>
                                          </div>

                                          <div className="hero-right">
                                                <div className="hero-card">
                                                      <div className="card-badge">Platform Snapshot</div>
                                                      <div className="card-lines">
                                                            <div className="line">
                                                                  <span>Marketplace</span>
                                                                  <strong>Live</strong>
                                                            </div>
                                                            <div className="line">
                                                                  <span>Prompt Economy</span>
                                                                  <strong>Growing</strong>
                                                            </div>
                                                            <div className="line">
                                                                  <span>Creator Focus</span>
                                                                  <strong>Primary</strong>
                                                            </div>
                                                      </div>
                                                      <div className="glow-orb"></div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </section>

                        <section className="about-story">
                              <div className="__container">
                                    <div className="story-grid">
                                          <div className="story-card intro-card">
                                                <span className="mini-title">Who We Are</span>
                                                <h2>A focused platform for prompt selling and discovery</h2>
                                                <p>
                                                      In a world where AI tools are growing fast, prompts have become valuable
                                                      digital assets. HeyPrompt exists to organize that value into a platform
                                                      where quality, discoverability, and creator growth matter.
                                                </p>
                                          </div>

                                          <div className="story-card mission-card">
                                                <span className="mini-title">Our Mission</span>
                                                <p>
                                                      We want to make it easier for prompt creators to showcase their work,
                                                      reach the right audience, and build sustainable digital income around
                                                      AI creativity.
                                                </p>
                                          </div>

                                          <div className="story-card vision-card">
                                                <span className="mini-title">Our Vision</span>
                                                <p>
                                                      To become a trusted destination where AI prompts are not just shared,
                                                      but valued as products, systems, and creative tools for the future.
                                                </p>
                                          </div>
                                    </div>
                              </div>
                        </section>

                        <section className="ceo-section">
                              <div className="__container">
                                    <div className="section-head">
                                          <span className="eyebrow">Founder & CEO</span>
                                          <h2>The person behind HeyPrompt</h2>
                                    </div>

                                    <div className="ceo-wrap">
                                          <div className="ceo-image-card">
                                                <div className="image-frame">
                                                      <img src={require('../asstes/images/seo.png')} alt="Founder & CEO" />
                                                </div>
                                          </div>

                                          <div className="ceo-content-card">
                                                <span className="mini-title">Sunil Sharma, ( Thedc )</span>
                                                <h3>Founder, Builder, Vision Driver</h3>
                                                <p>
                                                      Sunil Sharma founded HeyPrompt with a clear idea — prompts should not
                                                      stay scattered across the internet without structure, value, or ownership.
                                                      He envisioned a platform where creators could publish prompt-based
                                                      digital products in a clean and scalable way.
                                                </p>
                                                <p>
                                                      The focus behind HeyPrompt is not just listing prompts, but building a
                                                      serious ecosystem around AI creativity, prompt commerce, and creator-led
                                                      digital growth.
                                                </p>

                                                <blockquote>
                                                      “HeyPrompt is built to give AI creators a place where their ideas are
                                                      visible, valuable, and monetizable.”
                                                </blockquote>

                                                <div className="ceo-links">
                                                      {LinkMedias.map((item, i) => (
                                                            <OverlayTrigger key={i} overlay={<Tooltip>{item?.title}</Tooltip>}>
                                                                  <Link to={item?.url}  target="_blank" rel="noreferrer" title={item?.title}>{item?.icon}</Link>
                                                            </OverlayTrigger>
                                                      ))}
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </section>

                        <section className="platform-core">
                              <div className="__container">
                                    <div className="section-head center">
                                          <span className="eyebrow">Core Strengths</span>
                                          <h2>What makes HeyPrompt different</h2>
                                    </div>

                                    <div className="core-grid">
                                          {coreFeatures.map((item) => (
                                                <div className="core-card" key={item.id}>
                                                      <span className="count">{item.id}</span>
                                                      <h3>{item.title}</h3>
                                                      <p>{item.text}</p>
                                                </div>
                                          ))}
                                    </div>
                              </div>
                        </section>



                        <section className="about-stats">
                              <div className="__container">
                                    <div className="stats-box">
                                          {stats.map((item, index) => (
                                                <div className="stat-item" key={index}>
                                                      <h3>{item.value}</h3>
                                                      <p>{item.label}</p>
                                                </div>
                                          ))}
                                    </div>
                              </div>
                        </section>

                        <Community />
                  </main></>
      );
};

export default About;